import { atom } from "recoil";

import { keysOfRecoil } from "store/recoil/keys";

export const marketingAgreementState = atom<boolean>({
  key: keysOfRecoil.MARKETING_AGREEMENT,
  default: false,
});
